import WebflowPage from "./webflow/WebflowPage";
import ClassicPage from "./classic/ClassicPage";
import MayowaPage from "./mayowa/MayowaPage";

function normalizePath(pathname) {
  const path = pathname.replace(/\/+$/, "");
  return path || "/";
}

function AppRouter() {
  const path = normalizePath(window.location.pathname);

  if (path === "/classic") {
    return <ClassicPage />;
  }

  if (path === "/webflow") {
    return <WebflowPage />;
  }

  const canonicalPath = path.replace(/^\/mayowa(?=\/|$)/, "") || "/";
  return <MayowaPage path={canonicalPath} />;
}

export default AppRouter;
